const dubugLog =true//process.env.REACT_APP_REMOTE_LOG || process.env.REMOTE_LOG;  
let tag ="AppLogs"; 
let active=false; 
  
const log = {
 
  setLogs : (enable)=>{
    active = enable; 
  }, 
  message: (tag,text,value)=>{
    if(dubugLog===true || active){
      console.log(`${tag}> ${text}`,value?value:"");
    }
  }
}

export {
   log
}